import React, { useState, useCallback, useEffect } from "react";
import apiRoutes from "../../assets/apiRoutes.json";
import SelectBox from 'devextreme-react/select-box';
import DataSource from 'devextreme/data/data_source';
import CustomStore from 'devextreme/data/custom_store';
import axios from "axios";
import { connect } from "react-redux";
import LookupSearchDialog from "../services/LookupSearchDialog";
import { Width } from "devextreme-react/chart";
const AutoCompleteComponent = (props) => {
    var accessToken = props.oidc.user.access_token;
    const { lookupInfo, openLookupForm, setOpenLookupForm, setFormData, formData, dataSource, showOnlyConsigneeAttachedToCustomers, showOnlyShippersAttachedToCustomer } = props;
    const Profile = 4;
    const [selectBoxData, setSelectBoxData] = useState();
    const [selectedValue, setSelectedValue] = useState();
    const [transactionSelectedLookupData, setTransactionLookupSelectedData] = useState({});
    const setTransactionLookupData = (selectedValue) => {
        fetchData(lookupInfo.lookupType === Profile ? selectedValue[0].code : selectedValue[0].identityId);
        setSelectedValue(selectedValue[0]);
    }
    const onValueChanged = useCallback((e) => {
        setSelectedValue(e.value);
        var rowid = "";
        var name = "";
        var identityId  = "";
        var code = "";

        if (e.value)
        {
            if (e.value.rowid)
            {
                rowid = e.value.rowid;
            }

            if (e.value.name)
            {
                name = e.value.name;
            }

            if (e.value.identityId)
            {
                identityId = e.value.identityId;
            }

            if (e.value.code)
            {
                code = e.value.rowid;
            }
        }

        if (lookupInfo.name === "ShipperTo") {
            setFormData((prevFormData) => ({
                ...prevFormData,
                rShipperTo: rowid,
                shippernameto: name,  
            }));
        }
        if (lookupInfo.name === "ShipperFrom") {
            setFormData((prevFormData) => ({
                ...prevFormData,
                rShipperFrom:  rowid,
                shippernamefrom: name  
            }));
        }
        if (lookupInfo.name === "ConsigneeTo") {
            setFormData((prevFormData) => ({
                ...prevFormData,
                rConsigneeTo:  rowid,
                consigneenameto: name  
            }));
        }
        if (lookupInfo.name === "ConsigneeFrom") {
            setFormData((prevFormData) => ({
                ...prevFormData,
                rConsigneeFrom:  rowid,
                consigneenamefrom: name  
            }));
        }
        if (lookupInfo.name === "CustomerFrom") {
            setFormData((prevFormData) => ({
                ...prevFormData,
                rCustomerFrom:  rowid,
                customernamefrom: name
            }));
            const customerIdentityId = identityId;
            const trimmedcustomerIdentityId = customerIdentityId ? customerIdentityId.trim() : '';
            if(props.handelCustomerChange)
                props.handelCustomerChange(trimmedcustomerIdentityId);
        }
        if (lookupInfo.name === "CustomerTo") {
            setFormData((prevFormData) => ({
                ...prevFormData,
                rCustomerTo: rowid,
                customernameto: name
            }));
            const customerIdentityId = identityId;
            const trimmedcustomerIdentityId = customerIdentityId ? customerIdentityId.trim() : '';
            if(props.handelCustomerChange)
                props.handelCustomerChange(trimmedcustomerIdentityId);
        }
        if (lookupInfo.name === "Profile") {
            setFormData((prevFormData) => ({
                ...prevFormData,
                rProfile: rowid,
                profileVal: code,
            }));
        }
        if (lookupInfo.name === "ShipperVia") {
            setFormData((prevFormData) => ({
                ...prevFormData,
                rShipperVia: rowid,
                shippernameVia: name,
            }));
        }
    },  [lookupInfo, setFormData]);
    const fetchData = async (kValue) => {
        if(dataSource)
        {
            setSelectBoxData(dataSource);
        }
        else
        {
            setSelectBoxData(new DataSource({
                store: new CustomStore({
                    key: 'rowid',
                    load: async function (loadOptions) {
                        console.log("lookupType" + lookupInfo.lookupType);
                        console.log(JSON.stringify(loadOptions))
                        const searchValue = loadOptions.searchValue || kValue;
                        let request = {
                            identityIdFrom: searchValue,
                            code: searchValue,
                            lookupType: lookupInfo.lookupType,
                            IsAutoComplete:true,
                        };
                        return await axios.post(
                            lookupInfo.name === "Profile" ? `${window._env_.REACT_APP_APIS}/${apiRoutes.OM.SearchProfileLookup}`:`${window._env_.REACT_APP_APIS}/${apiRoutes.OM.SearchLookup}`,
                            request,
                            {
                                headers: {
                                    "Content-Type": "application/json",
                                    access_token: accessToken,
                                    Authorization: `Bearer ${accessToken}`,
                                },
                            }
                        )
                            .then(response => response.data.lookups)
                            .catch(error => {
                                console.error('Error fetching data:', error);
                                return [];
                            });
                    },
                    byKey: async function (key) {
                        let request = {
                            identityIdFrom: kValue,
                            code: kValue,
                            lookupType: lookupInfo.lookupType,
                            isAutoComplete: true,
                        };
                        return await axios.post(
                            lookupInfo.name === "Profile" ? `${window._env_.REACT_APP_APIS}/${apiRoutes.OM.SearchProfileLookup}`:`${window._env_.REACT_APP_APIS}/${apiRoutes.OM.SearchLookup}`,
                            request,
                            {
                                headers: {
                                    "Content-Type": "application/json",
                                    access_token: accessToken,
                                    Authorization: `Bearer ${accessToken}`,
                                },
                            }
                        )
                            .then(response => response.data.lookups)
                            .catch(error => {
                                console.error('Error fetching data:', error);
                                return [];
                            });
                    }
                })
            }));
        }   
    }
    useEffect(() => {
        fetchData('');
    }, []);
    useEffect(() => {
        setSelectedValue(null);
      }, [props.resetTrigger]);
    return (
        <div className="col-md-11 auto-complete-selectbox">
            <SelectBox
                dataSource={selectBoxData}
                displayExpr={lookupInfo.name === "Profile" ? "code" : "identityId"}
                searchEnabled={true}
                stylingMode='outlined'
                labelMode="static"
                label={lookupInfo.label}
                onValueChanged={onValueChanged}
                valueChangeEvent="keyup"
                value={selectedValue}
            />
            {
                openLookupForm ?
                    <LookupSearchDialog
                        openLookupForm={openLookupForm}
                        setOpenLookupForm={setOpenLookupForm}
                        setReceipt={setFormData} 
                        receipt={formData}
                        lookupFormName={lookupInfo.name}
                        lookup={lookupInfo}
                        setTransactionLookupData={setTransactionLookupData}
                        transactionSelectedLookupData={transactionSelectedLookupData}
                        setTransactionLookupSelectedData={setTransactionLookupSelectedData}
                        showOnlyConsigneeAttachedToCustomers={showOnlyConsigneeAttachedToCustomers}
                        showOnlyShippersAttachedToCustomer={showOnlyShippersAttachedToCustomer}
                    /> : null
            }
        </div>
    );
};
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(AutoCompleteComponent);